import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaDocumentosCotizacion', NominasNominaDocumentosCotizacion)

function NominasNominaDocumentosCotizacion($api, $schema) {
  this.get = get

  function get(data) {
    return $api.open('/api/nominas/nomina/documentos/cotizacion',
      $schema(data, NominasNominaDocumentosCotizacionSchema, true),
      'nominas_nomina_documentos_cotizacion')
  }

  let NominasNominaDocumentosCotizacionSchema = {
    agrupar_departamentos: 'boolean',
    desglosar_cotizacion: 'boolean',
    moneda_alternativa: 'boolean',
    separar_impuesto_estatal: 'boolean',
    totalizar_departamentos: 'boolean',
    totalizar_remunerados: 'boolean',
    guardar_configuracion: 'boolean',
    incluir_isr: 'boolean',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Cotizacion.js